<template>
    <div class="title">
        {{ data.title }}
    </div>
</template>

<script setup lang="ts">
import type { FooterItemTitleFragment } from '@/graphql/api'

defineProps<{
    data: FooterItemTitleFragment
}>()
</script>

<style lang="scss" scoped>
.title {
    font-family: $sectra-font-stack;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.25rem;
    margin-bottom: 10px;
}
</style>
